import React from 'react'

class DeleteTransactionButton extends React.Component {

    render() {
        return <button className="btn btn-lnk" onClick={() => this.props.removeTransaction(this.props.index)}><small>{this.props.btnLabel}</small></button>;
    }
}

export default DeleteTransactionButton